import React, { useState } from "react";
import cn from "classnames";
import { useFormField } from "state/hooks";
import CodeEditor from "components/fields/code/CodeEditor";
import IconButton from "components/IconButton";
import SelectList, {
    SelectListDivider,
    SelectListItem,
} from "playground/ui/SelectList";
import Popover from "components/Popover";
import plugins from "./plugins";

//import PropTypes from 'prop-types';

function HyperscriptPlugins(props) {
    const { value, onChange } = props;
    const [current, setCurrent] = useState();

    const handleChange = (v) => {
        try {
            const parsed = JSON.parse(v);
            onChange(parsed);
        } catch (e) {}
    };

    const installed = value.map((p) => p.id);
    const available = Object.keys(plugins);

    const params = plugins[current]?.params || {};

    const addPlugin = (p) => {
        if (installed.includes(p)) return;
        onChange([...value, { id: p, params: {} }]);
        setCurrent(p);
    };

    const removePlugin = (p) => {
        const next = value.filter((v) => v.id !== p);
        onChange(next);
        setCurrent(next[0]?.id);
    };

    return (
        <>
            <div className={"cols cols-spread"}>
                <div className={"style-elements-select"}>
                    {installed.map((p) => (
                        <div
                            className={cn("style-element-item", {
                                "is-selected": p === current,
                            })}
                            onClick={() => setCurrent(p)}
                            key={p}
                        >
                            {plugins[p].name}
                        </div>
                    ))}
                </div>
                <Popover
                    trigger={({ onClick }) => (
                        <IconButton icon={"mui-more_vert"} onClick={onClick} />
                    )}
                    content={({ onClose }) => (
                        <SelectList onClick={onClose}>
                            {current && (
                                <>
                                    <SelectListItem
                                        onClick={() => removePlugin(current)}
                                    >
                                        Remove {current}
                                    </SelectListItem>
                                    <SelectListDivider />
                                </>
                            )}
                            {available.map((p) => (
                                <SelectListItem
                                    key={p}
                                    onClick={() => addPlugin(p)}
                                >
                                    {plugins[p].name}
                                </SelectListItem>
                            ))}
                        </SelectList>
                    )}
                />
            </div>
            <div className={"style-panel-content"}>
                {Object.keys(params).map((param) => (
                    <div className={"style-prop"}>
                        <div className={"style-prop-label"}>{param}</div>
                        <div className={"style-prop-content"}>
                            {params[param].type}
                        </div>
                    </div>
                ))}
            </div>
            {/*<CodeEditor*/}
            {/*    value={JSON.stringify(value, null, 2)}*/}
            {/*    onChange={handleChange}*/}
            {/*/>*/}
        </>
    );
}

export function HyperscriptEditor(props) {
    const { value: attrValue, onChange: attrChange } =
        useFormField("attributes");
    const value = attrValue?._ || "";
    const onChange = (v) => {
        attrChange({ ...(attrValue || {}), _: v });
    };
    const pluginsValue = attrValue?.plugins || [];
    const pluginsOnChange = (v) => {
        attrChange({ ...(attrValue || {}), plugins: v });
    };
    return (
        <div className={"rows gap-md"}>
            <HyperscriptPlugins
                value={pluginsValue}
                onChange={pluginsOnChange}
            />
            <CodeEditor value={value} onChange={onChange} />
        </div>
    );
}

HyperscriptEditor.propTypes = {};

HyperscriptEditor.defaultProps = {};

export default HyperscriptEditor;
